import * as React from 'react';
import { useTheme } from '@mui/material';
import DialogContent from '@mui/material/DialogContent';
import { useTranslation } from 'react-i18next';
import * as Device from 'react-device-detect';

import { useSession } from '@hooks';
import { useGetAccountNotificationsQuery, GetAccountNotificationsQuery } from '@graphql';
import { NotificationForm } from './form';
import Header from '../header';

interface NotificationSettingsDialogProps {
  handleCloseDialog: () => void;
}

export function NotificationSettingsDialog(props: Readonly<NotificationSettingsDialogProps>) {
  const { handleCloseDialog } = props;
  const [notifications, setNotifications] = React.useState<
    GetAccountNotificationsQuery['getAccountNotifications'] | null
  >(null);
  const theme = useTheme();
  const { account } = useSession();
  const { t } = useTranslation('notification');

  useGetAccountNotificationsQuery({
    skip: !account,
    onCompleted({ getAccountNotifications }) {
      setNotifications(getAccountNotifications);
    },
  });

  if (!notifications) {
    return null;
  }

  return (
    <>
      <Header
        title={t('Notification settings')}
        Icon={theme.icons.notificationEdit}
        handleCloseDialog={handleCloseDialog}
      />
      <DialogContent
        sx={{
          pt: Device.isMobile ? 10 : 3,
          px: Device.isMobile ? 2 : 5,
          pb: 5,
        }}
      >
        <NotificationForm notifications={notifications} />
      </DialogContent>
    </>
  );
}
